// src/lib/featuredVideos.js
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  Timestamp,
} from 'firebase/firestore'
import { db } from '../firebase' // 👈 même fichier que pour dealsSlider

const COL = collection(db, 'featuredVideos')

// 🔹 Pour le public : uniquement les vidéos actives et dans la fenêtre de dates
export async function fetchActiveFeaturedVideos() {
  const now = Timestamp.now()

  const q = query(
    COL,
    where('isActive', '==', true),
    where('startsAt', '<=', now),
    where('endsAt', '>=', now),
    orderBy('startsAt', 'desc'),
    orderBy('order', 'asc')
  )

  const snap = await getDocs(q)
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }))
}

// 🔹 Pour l’admin : tout, trié par ordre + date
export async function fetchAllFeaturedVideos() {
  const q = query(COL, orderBy('startsAt', 'desc'), orderBy('order', 'asc'))
  const snap = await getDocs(q)
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }))
}

// 🔹 Create
export async function createFeaturedVideo(data) {
  const payload = normalizePayload(data)
  const docRef = await addDoc(COL, payload)
  return { id: docRef.id, ...payload }
}

// 🔹 Update
export async function updateFeaturedVideo(id, data) {
  const ref = doc(db, 'featuredVideos', id)
  const payload = normalizePayload(data)
  await updateDoc(ref, payload)
}

// 🔹 Delete
export async function deleteFeaturedVideo(id) {
  const ref = doc(db, 'featuredVideos', id)
  await deleteDoc(ref)
}

// ---- helpers ----
function normalizePayload(data) {
  // data.startsAt / data.endsAt sont des string "YYYY-MM-DDTHH:mm"
  // on les convertit en Timestamp Firestore
  const now = new Date()

  const starts = data.startsAt
    ? new Date(data.startsAt)
    : now

  const ends = data.endsAt
    ? new Date(data.endsAt)
    : new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000) // +7 jours par défaut

  return {
    title: data.title || '',
    creatorHandle: data.creatorHandle || '',
    videoUrl: data.videoUrl || '',
    price: Number(data.price || 0),
    currency: data.currency || 'XOF',
    productName: data.productName || '',
    productImage: data.productImage || '',
    productHref: data.productHref || '/catalog',
    order: Number(data.order || 0),
    isActive: !!data.isActive,
    startsAt: Timestamp.fromDate(starts),
    endsAt: Timestamp.fromDate(ends),
  }
}
